export const getUserIdFromUrl = () => {
  const url = new URL(window.location.href);
  const pathParts = url.pathname.split("/").filter(Boolean);
  
  // /userId/admin formatında ise userId'yi al
  if (pathParts.length >= 2 && pathParts[pathParts.length - 1] === 'admin') {
    return pathParts[pathParts.length - 2] || "";
  }
  
  // Normal durumda son parçayı al
  const userId = pathParts[pathParts.length - 1];
  return userId || "";
};
